<template>
  <div>
    <div class="mb-4">
      <div class="flex items-center py-2">
        Are you sure you want to delete '{{ content.title }}'?
      </div>
    </div>
    <div class="flex lg:flex-1 mt-4 lg:mt-0 justify-start self-start md:flex-none w-full">
      <button :class="buttonState" class="flex-no-shrink bg-red-dark hover:bg-red-darker border-red-dark hover:border-red-darker text-sm border-4 text-white py-1 px-2 rounded" type="button" @click="deleteContent()">
        Delete
      </button>
      <button class="flex-no-shrink border-transparent border-4 text-blue-dark hover:text-blue-darkest text-sm py-1 px-2 rounded" type="button" @click="$router.push('/content')">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "content-edit",
  props: {
    id: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      confirmedDelete: true
    };
  },
  computed: {
    buttonState() {
      if (this.confirmedDelete) {
        return [
          "cursor-not-allowed",
          "opacity-50",
          "hover:bg-red-dark",
          "hover:border-red-dark"
        ];
      }
      return {};
    },
    ...mapState({
      content: state => state.content
    })
  },
  beforeMount() {
    this.$store.dispatch("INIT_CONTENT");
    this.$store
      .dispatch("LOAD_CONTENT", this.id)
      .then(() => (this.confirmedDelete = false));
  },
  methods: {
    deleteContent() {
      if (!this.confirmedDelete) {
        this.confirmedDelete = true;
        this.$store
          .dispatch("DELETE_CONTENT")
          .then(() => this.$router.push("/content"));
      }
    }
  }
};
</script>
